import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["amount", "children"];
import React from "react";
import { TextButton } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PayPalBNPLLearnMoreButton = function PayPalBNPLLearnMoreButton(_ref) {
  var amount = _ref.amount,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? "Learn more" : _ref$children,
      props = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(TextButton, _extends({
    "data-pp-messagesmodal": true,
    "data-pp-amount": amount || "",
    role: "button",
    "aria-label": "Learn more about PayPal Pay in 4"
  }, props), children));
};